import { Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild, Renderer2, ElementRef } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AppConstants } from 'src/app/classes/app/constants';
import { IStoryExtended, IStory, IStoryResponse, IStoryUnlock, IStoryPhoto, IStoryProduct, IStoryBundle, IStoryBundleType } from 'src/app/classes/def/core/story';
import { IAppLocation } from 'src/app/classes/def/places/app-location';
import { IonContent, IonHeader, ModalController, Platform } from '@ionic/angular';
import { INavParams, IViewSpecs } from 'src/app/classes/def/nav-params/general';
import { ThemeColors } from 'src/app/classes/def/app/theme';
import { Messages, ETutorialEntries } from 'src/app/classes/def/app/messages';
import { ErrorMessage } from 'src/app/classes/general/error-message';
import { EStandardCode, EStandardStoryCode } from 'src/app/classes/def/core/activity';
import { EMessageTrim } from 'src/app/classes/utils/message-utils';
import { ICheckStoryProviders, StoryUtils } from 'src/app/classes/utils/story-utils';
import { LocationUtils } from 'src/app/services/location/location-utils';
import { IBackendLocation, ILocationContainer } from 'src/app/classes/def/places/backend-location';
import { ResourceManager } from 'src/app/classes/general/resource-manager';
import { IPopoverActions } from 'src/app/classes/def/app/modal-interaction';
import { EModalTypes } from 'src/app/classes/utils/uiext';
import { UiExtensionService } from 'src/app/services/general/ui/ui-extension';
import { AnalyticsService } from 'src/app/services/general/apis/analytics';
import { BackButtonService } from 'src/app/services/general/ui/back-button';
import { ResourcesCoreDataService } from 'src/app/services/data/resources-core';
import { SettingsManagerService } from 'src/app/services/general/settings-manager';
import { TutorialsService } from 'src/app/services/app/modules/minor/tutorials';
import { ERouteDef } from 'src/app/app-utils';
import { NavParamsService, INavParamsInfo } from 'src/app/services/app/nav-params';
import { ENavParamsResources } from 'src/app/classes/def/nav-params/resources';
import { GameStatsService } from 'src/app/services/app/utils/game-stats';
import { UiExtensionStandardService } from 'src/app/services/general/ui/ui-extension-standard';
import { EAppIconsStandard, EAppIcons, EImgIcons, EMarkerIcons } from 'src/app/classes/def/app/icons';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { QRFrameViewComponent } from 'src/app/modals/generic/modals/qr-frame/qr-frame.component';
import { IPlatformFlags } from 'src/app/classes/def/app/platform';
import { BusinessDataService } from 'src/app/services/data/business';
import { EStoryReleaseFlag, EStoryUnlock, EStoryUnlockType } from 'src/app/classes/def/business/story';
import { PopupFeaturesService } from 'src/app/services/app/modules/minor/popup-features';
import { IMarketplaceBrowseNavParams, IMarketplaceDetailNavParams } from 'src/app/classes/def/nav-params/marketplace';
import { MarketplaceDataService } from 'src/app/services/data/marketplace';
import { IGenericResponse } from 'src/app/classes/def/requests/general';
import { DomSanitizer, Meta } from '@angular/platform-browser';
import { ITutorial } from 'src/app/classes/def/app/tutorials';
import { FileManagerService } from 'src/app/services/media/file';
import { IQRFrameCallbackData, IQRCodeSlide, IQRFrameParams, StoryQRUtils } from 'src/app/classes/utils/story-qr-utils';
import { PlacesDataService } from 'src/app/services/data/places';
import { Util } from 'src/app/classes/general/util';
import { IFaqCategory } from 'src/app/classes/def/support/support';
import { EFAQCategories, SupportDataService } from 'src/app/services/data/support';
import { StringUtils } from 'src/app/services/app/utils/string-utils';
import { PaymentStripeDataService } from 'src/app/services/data/payment-stripe';
import { EmailFormatUils } from 'src/app/services/utils/email-format';
import { IUnlockContentCheckoutParams, IUnlockContentCheckoutReturnData, UnlockContentCheckoutComponent } from 'src/app/modals/app/modals/unlock-content-checkout/unlock-content-checkout.component';
import { EAlertButtonCodes } from 'src/app/classes/def/app/ui';
import { IGameItemIAP } from 'src/app/classes/def/items/game-item';
import { EDroneMode } from 'src/app/services/data/activities';
import { IDBModelCountry } from 'src/app/classes/def/world/world';
import { Location } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { IDistFlags } from 'src/app/classes/def/app/app';
import { ICustomFiltersContainer } from 'src/app/classes/def/app/filters';
import { ESettingsType } from 'src/app/classes/def/app/settings';
import { CustomFormViewComponent } from 'src/app/modals/generic/modals/custom-form/custom-form.component';
import { GeneralCache } from 'src/app/classes/app/general-cache';
import { Title } from "@angular/platform-browser";
import { IEditorSettings } from 'src/app/classes/def/core/editor';
import { IBookingCheckReturn } from 'src/app/components/app/components/booking-check/booking-check.component';
import { EOTA, EProviderPrefix, IBookingInfoContent, IBookingInterceptorResult, IStoryProductBooking } from 'src/app/classes/def/core/booking';
import { IDBModelLanguage, IStoryListNavParams } from 'src/app/classes/def/nav-params/story';
import { ILeplaceLeafletMarker } from 'src/app/components/app/components/leplace-map/leplace-map.component';
import { ILatLng } from 'src/app/classes/def/map/coords';
import { EMarkerIconType } from 'src/app/classes/def/map/markers';
import { LocationManagerService } from 'src/app/services/map/location-manager';
import { GeometryUtils } from 'src/app/services/utils/geometry-utils';
import { IDateSelectorEntry } from 'src/app/modals/generic/modals/date-selector/date-selector.component';
import { ScrollUtils } from 'src/app/services/utils/scroll-utils';
import i18next from 'i18next';
import { I18nService } from 'src/app/services/general/ui/i18n.service';
import { SleepUtils } from 'src/app/services/utils/sleep-utils';
import { EAudioGuide } from 'src/app/classes/def/core/interactive-features';
import { TextToSpeechService } from 'src/app/services/general/apis/tts';
import { PromiseUtils } from 'src/app/services/utils/promise-utils';

interface IUnlockCodeSpecDict {
  searchShort: IUnlockCodeSpec,
  search: IUnlockCodeSpec,
  unlockShort: IUnlockCodeSpec,
  unlock: IUnlockCodeSpec,
  unlockPartner: IUnlockCodeSpec,
  redeem: IUnlockCodeSpec,
  redeemShort: IUnlockCodeSpec
}

interface IUnlockCodeSpec {
  name: string,
  input: boolean,
  length: number,
  code: string,
  show: boolean,
  isQR: boolean
}

@Component({
  selector: 'app-marketplace-content',
  templateUrl: './content.page.html',
  styleUrls: ['./content.page.scss'],
  animations: [
    trigger('showState', [
      state('inactive', style({
        // transform: 'translateY(-100%)',
        opacity: 0
      })),
      state('active', style({
        // transform: 'translateY(0)',
        opacity: 1
      })),
      transition('inactive => active', animate(AppConstants.animationMode)),
      transition('active => inactive', animate(AppConstants.animationMode))
    ])
  ],
  encapsulation: ViewEncapsulation.None
})
export class MarketplaceContentPage implements OnInit, OnDestroy {
  @ViewChild("header", { read: IonHeader, static: false }) header: HTMLElement;
  @ViewChild("content", { read: IonContent, static: false }) content: HTMLElement;
  @ViewChild('startButtonBar', { read: ElementRef, static: false }) startButtonBar: ElementRef<Element>;

  website: string = AppConstants.links.website;
  testFlightUrl: string = AppConstants.links.testFlightUrl;
  appStoreUrl: string = AppConstants.links.appStoreUrl;
  playStoreUrl: string = AppConstants.links.playStoreUrl;
  webUrl: string = AppConstants.links.webUrl;
  webUrlDisp: string = AppConstants.links.webUrlDisp;
  termsUrl: string = AppConstants.links.termsUrl;
  registerTesterCalendlyUrl: string = AppConstants.links.registerTesterCalendly;

  subscription = {
    languageChanged: null
  };

  enableWeb: boolean = true;

  storyExt: IStoryExtended;
  story: IStory;
  description: string;
  appIcons = EAppIcons;
  appIconsStandard = EAppIconsStandard;
  imgIcons = EImgIcons;

  storyId: number = 0;
  title: string = "Storyline Connect Page";
  loaded: boolean = false;
  loadedPage: boolean = false;
  saved: boolean = false;
  storyLoaded: boolean = false;
  reload: boolean = true;
  locationURL: string = null;
  useDefaultLocationPhotos: boolean = true;
  params: IMarketplaceDetailNavParams;
  coords: ILatLng;
  startButtonText: string = i18next.t("ui:actions.start") as string;
  showState: string = "inactive";
  timeouts = {
    init: null
  };
  theme: string = "theme-light theme-light-bg";
  mapStyleName: string = null;
  appLocations: IAppLocation[] = [];
  photoUrl: string = "";
  photoLoaded: boolean = false;
  animate: boolean = true;

  np: INavParams = null;
  vs: IViewSpecs;
  isModal: boolean = true;
  fromMarket: boolean = false;
  unlockCodes: string[] = null;
  unlockCodeShortLength: number = 5;

  potentialXp: number = 0;
  levelDisp: string = "";
  unlockInProgress: boolean = false;
  zoomState: boolean = false;

  categoryName: string = "";

  platform: IPlatformFlags = {} as IPlatformFlags;

  tutorialEmbed: string;
  tutorialEmbedPDFLink: any;
  tutorialPreviewLink: string;

  infoText = {
    reviewContact: null,
    howItWorks: null,
    reviewContactIcon: null,
    howItWorksIcon: null,

    mapPreview: null,
    mapPreviewIcon: null,

    appNotes: null,
    webNotes: null,
    testFlightNotes: null,
    checkoutNotes: null,
    unlockNotes: null,
    findStoryNotes: null,

    appStoreNotes: null,
    playStoreNotes: null,

    connectHeader: null,
    connectNotes: null
  };

  isDev: boolean = false;
  isBeta: boolean = false;

  distInit: IDistFlags = {
    android: false,
    ios: false,
    mobile: true,
    web: true
  };

  dist: IDistFlags = {

  } as IDistFlags;

  hasProviders: boolean = false;
  storyProviders: IBackendLocation[] = [];
  hasStoryProducts: boolean = false;
  storyProducts: IStoryProduct[] = [];

  activationCodes: IUnlockCodeSpecDict = {
    search: null,
    searchShort: null,
    unlock: null,
    unlockShort: null,
    unlockPartner: null,
    redeem: null,
    redeemShort: null
  };

  activationCodesList: IUnlockCodeSpec[] = [];
  activationCodesQRList: IUnlockCodeSpec[] = [];

  hasActivationCodes: boolean = false;
  hasActivationQRCodes: boolean = false;
  hasRedeemQRCodes: boolean = false;

  partnerUnlock: boolean = false;
  linkPreview: boolean = true;

  token: string = null;
  fromBundle: boolean = false;
  unlockCodeGranted: string = null;

  extDataLoaded: boolean = false;
  faqCategories: IFaqCategory[];
  faqActivation: IFaqCategory = null;

  isPremium: boolean = false;
  isTestFlightOnly: boolean = false;

  tutorialVideoUrl: string = null;
  tutorialVideoExtUrlMobile: string = null;

  showActivationGuide: boolean = false;
  showActivationPDFGuide: boolean = false;

  // appDetails: IAppVersionDB = null;

  isCheckout: boolean = false;
  enableCheckout: boolean = false;
  noCheckout: boolean = false;
  isTester: boolean = false;
  isPoster: boolean = false;
  connectMode: number = null;

  isQRTracking: boolean = false;
  isTracking: boolean = false;
  isVanityTracking: boolean = false;
  alternativePrice: string = "";
  alternativePricePromo: string = "";

  storyPhotos: IStoryPhoto[] = null;

  defaultUnlock: string = "UNLOCK";
  buyMoreLabel: string = "<book more>";

  descriptionRedeemBooking: string = "<use booking reference>";

  settings: IEditorSettings;

  useStripe: boolean = true;
  shopifyLink: string = null;

  isBundle: boolean = false;
  bundleContents: IStoryExtended[] = [];

  storyMarkers: ILeplaceLeafletMarker[] = [];
  zoomLevel: number = 2;
  zoomOutLevel: number = 2;
  mapCenter: number[] = [45, 0];
  loading: boolean = true;

  reloadMap: boolean = false;

  activeCards = {
    intro: true,
    preview: true,
    tutorial: true,
    setup: true,
    checkout: false,
    checkoutMore: false,
    registerTester: false,
    checkBooking: true,
    viewListings: true,
    faq: true,
    contact: true
  };

  bookingDateSelector: IDateSelectorEntry = {
    id: 'pd',
    heading: 'Booking Date',
    code: 1,
    full: true,
    dateOnly: true
  };

  bookingData: IStoryProductBooking = {
    customerEmail: null,
    customerName: null,
    customerPhone: null,
    bookingAmount: 1
  };

  descriptionFooter: string = "<scroll down for instructions>";
  descriptionFooterKey: string = "connect:labels.scrollDownForInstructions";

  langIcon: string = EAppIcons.translate;
  langCode: string = "en-US";

  languageDisp: IDBModelLanguage = null;
  selectedTranslationId: number = null;

  isMultiLanguage: boolean = false;
  langs: IDBModelLanguage[] = null;
  langInit: boolean = false;

  storyLoadedInit: boolean = false;

  withAudioGuide: boolean = false;
  audioGuideAutoplay: boolean = false;

  // images = [944, 1011, 984].map((n) => `https://picsum.photos/id/${n}/900/500`);

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public location: Location,
    public marketplaceDataService: MarketplaceDataService,
    public uiext: UiExtensionService,
    public uiextStandard: UiExtensionStandardService,
    public plt: Platform,
    public analytics: AnalyticsService,
    public backButton: BackButtonService,
    public resourcesProvider: ResourcesCoreDataService,
    public settingsProvider: SettingsManagerService,
    public businessData: BusinessDataService,
    public modalCtrl: ModalController,
    public tutorials: TutorialsService,
    public nps: NavParamsService,
    public gameStats: GameStatsService,
    public popupFeatures: PopupFeaturesService,
    public domSanitizer: DomSanitizer,
    public fileManager: FileManagerService,
    public placesData: PlacesDataService,
    public element: ElementRef,
    public renderer: Renderer2,
    public support: SupportDataService,
    public paymentStripe: PaymentStripeDataService,
    public meta: Meta,
    public el: ElementRef,
    public titleService: Title,
    public locationManager: LocationManagerService,
    public i18nService: I18nService,
    public tts: TextToSpeechService
  ) {
    // customize default values of carousels used by this component tree
    // carouselConfig.interval = 2000;
    // carouselConfig.keyboard = true;
    // carouselConfig.pauseOnHover = true;
    this.resetDistFlags();
  }

  // in my case i'm using ionViewWillEnter
  ionViewWillEnter() {
    console.log("will enter");
    if (!this.isModal) {
      this.renderer.setStyle(this.header['el'], 'webkitTransition', 'top 300ms');
      this.renderer.setStyle(this.content['el'], 'webkitTransition', 'top 300ms');
    }
  }

  scrollToStart() {
    console.log("scroll to start");
    ScrollUtils.scrollIntoView(null, this.startButtonBar.nativeElement, null, 30);
  }

  onContentScroll(event) {
    if (!this.isModal) {
      let target = event.target;
      let offsetHeader: number = 56;
      let offsetContent: number = 26;
      if (target.scrollTop >= 50) {
        this.renderer.setStyle(this.header['el'], 'top', '-' + offsetHeader + 'px');
        this.renderer.setStyle(this.content['el'], 'top', '-' + offsetContent + 'px');
      } else {
        this.renderer.setStyle(this.header['el'], 'top', '0px');
        this.renderer.setStyle(this.content['el'], 'top', '0px');
      }
    }
  }

  scrollTo(sectionId: string) {
    const section = this.el.nativeElement.querySelector(`#${sectionId}`);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    // ScrollUtils.scrollIntoView(null, this.el.nativeElement.querySelector(`#${sectionId}`), null, 30);
  }

  updatePageMetadata() {
    // this.meta.updateTag({ property: 'og:title', content: 'YOUR_TITLE' });
    // this.meta.updateTag({ property: 'og:image', content: 'YOUR_IMAGE' });
    this.meta.updateTag({ property: 'og:url', content: 'https://connect.leplace.online/storyline?storyId=' + this.storyId + "&token=" + this.token });
  }

  updatePageTitle(title: string) {
    this.titleService.setTitle("LP Connect | " + title);
    // this.timeouts.init = setTimeout(() => {
    //   this.titleService.setTitle("LP Connect | " + title);
    // }, 1000);
  }

  /**
   * load aux data (e.g., tutorials)
   */
  async loadExtData() {
    try {
      let category: number = EFAQCategories.stories;
      if (this.story.droneOnly === EDroneMode.onlyDrone) {
        category = EFAQCategories.storiesVirtual;
      }

      let cats: IFaqCategory[] = await this.support.getFaqV2([category, EFAQCategories.app, EFAQCategories.activation]);
      this.faqCategories = cats.filter(c => c.code !== EFAQCategories.activation);
      this.faqActivation = cats.find(c => c.code === EFAQCategories.activation);

      this.extDataLoaded = true;
      // cache all tutorials before loading
      await this.resourcesProvider.getInfoDataMultiCache([
        ETutorialEntries.reviewContact,
        ETutorialEntries.howItWorks,
        ETutorialEntries.checkoutNote,
        ETutorialEntries.activateStoryTutorialEn,
        ETutorialEntries.storylineTutorialVideo,
        ETutorialEntries.appNotes,
        ETutorialEntries.testFlightNotes,
        ETutorialEntries.webNotes,
        ETutorialEntries.checkoutNotes,
        ETutorialEntries.unlockNotes,
        ETutorialEntries.findStoryNotes,
        ETutorialEntries.mapPreview], false);

      // the tutorials have been preloaded in one pass at this point

      let tutorial: ITutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.reviewContact, true);
      this.infoText.reviewContact = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);
      this.infoText.reviewContactIcon = tutorial.photoUrl;

      tutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.howItWorks, true);
      this.infoText.howItWorks = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);
      this.infoText.howItWorksIcon = tutorial.photoUrl;

      tutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.appNotes, true);
      this.infoText.appNotes = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);

      tutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.testFlightNotes, true);
      this.infoText.testFlightNotes = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);

      tutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.webNotes, true);
      this.infoText.webNotes = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);

      tutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.checkoutNotes, true);
      this.infoText.checkoutNotes = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);

      tutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.unlockNotes, true);
      this.infoText.unlockNotes = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);

      tutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.findStoryNotes, true);
      this.infoText.findStoryNotes = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);

      tutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.mapPreview, true);
      this.infoText.mapPreview = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);
      this.infoText.mapPreviewIcon = tutorial.photoUrl;


      tutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.appStoreNotes, true);
      this.infoText.appStoreNotes = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);

      tutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.playStoreNotes, true);
      this.infoText.playStoreNotes = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);

      tutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.connectHeader, true);
      this.infoText.connectHeader = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);

      tutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.connectNotes, true);
      this.infoText.connectNotes = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);

      // tutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.howItWorks, true);
      // this.howItWorks = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);
      // this.howItWorksIcon = tutorial.photoUrl;
      // let data: IAppVersionDB = await this.resourcesProvider.getAppDetailsFromServer(EAppId.connect);
      // this.appDetails = data;
    } catch (err) {
      this.analytics.dispatchError(err, "content");
      console.error(err);
    }
  }

  watchLanguageChanged() {
    if (!this.subscription.languageChanged) {
      this.subscription.languageChanged = this.i18nService.watchLanguageChanged().subscribe(async (changed: boolean) => {
        if (!changed) {
          return;
        }
        console.log("language change detected");
        this.syncLangQueryParam();
        if (this.storyLoaded) {
          this.applyLanguageStoryTranslation(false);
          await this.loadExtData();
          this.loadTutorialPDF();
          this.loadTutorialVideoLink();
        } else {
          console.log("skipping first loaded");
        }
      }, (err) => {
        console.error(err);
      });
    }
  }

  async ngOnInit() {
    this.updatePageMetadata();
    this.analytics.trackView("content");
    await this.i18nService.checkWaitTranslationsLoaded();
    this.watchLanguageChanged();
    console.log("translations loaded");
    this.nps.checkParamsLoaded().then(() => {
      let npInfo: INavParamsInfo = this.nps.getCombined(ENavParamsResources.marketplaceContent, null, this.np);
      console.log("nav params: ", npInfo.params);
      let npar = npInfo.params;
      this.unlockCodeShortLength = AppConstants.gameConfig.unlockCodeLength;

      let hasParams: boolean = npInfo.hasParams;
      let promiseParams: Promise<boolean> = new Promise((resolve) => {
        if (hasParams) {
          console.log("has params: ", npar);
          let np: INavParams = npar;
          if (np && np.params) {
            this.params = np.params;
            // params already in object form
          }
          this.vs = np.view;
          this.isModal = this.vs ? this.vs.isModal : false;
          this.linkPreview = this.params.standalone ? true : false;
          this.fromMarket = this.params.fromMarket;
          this.unlockCodes = this.params.unlockCodes;

          // remove temp params for next reload
          this.removeTempParams();
          resolve(true);
        } else {
          this.storyId = 0;
          this.isModal = false;
          this.route.queryParams.subscribe((params: Params) => {
            if (params) {
              let data: IMarketplaceDetailNavParams = params as any;
              this.params = Object.assign({}, data);
              // params in stringified form to object form
              this.parseURLParams();
              // remove temp params for next reload
              this.removeTempParams();
            }
            resolve(true);
          });
        }
      });
      promiseParams.then(async () => {
        console.log("loading params: ", this.params);
        this.loadedPage = true;
        await this.loadParams();
        this.dispActiveCards();
        console.log("from bundle: ", this.fromBundle);
        // can be opened either as a modal or a root page
        this.plt.ready().then(() => {
          this.backButton.pushOrReplace(() => {
            this.back();
          }, this.vs);
        }).catch((err: Error) => {
          console.error(err);
        });

        this.settingsProvider.watchPlatformFlagsLoaded().subscribe((loaded: boolean) => {
          if (loaded) {
            this.platform = SettingsManagerService.settings.platformFlags;
          }
        }, (err: Error) => {
          console.error(err);
        });

        this.settingsProvider.getSettingsLoaded(false).then((res) => {
          if (res) {
            this.theme = ThemeColors.theme[SettingsManagerService.settings.app.settings.theme.value].css;
            this.loadAll();
          }
        }).catch((err: Error) => {
          console.error(err);
        });
      });
    }).catch((err: Error) => {
      console.error(err);
    });
  }

  parseURLParams() {
    this.params.storyId = Number.parseInt(this.params.storyId as any);
    this.params.checkout = this.params.checkout as any === "true";
    this.params.nocheckout = this.params.nocheckout as any === "true";
    this.params.qr = this.params.qr as any === "true";
    this.params.var = this.params.var as any === "true";
    this.params.tester = this.params.tester as any === "true";
    this.params.poster = this.params.poster as any === "true";
    this.linkPreview = true;
    console.log("parsed params: ", this.params);
  }

  async loadParams() {
    this.storyId = this.params.storyId;
    this.reload = this.params.reload;
    this.token = this.params.token;

    this.unlockCodeGranted = this.params.unlock;
    this.isCheckout = this.params.checkout;
    this.noCheckout = this.params.nocheckout;
    this.isQRTracking = this.params.qr;
    this.isTester = this.params.tester;
    this.isPoster = this.params.poster;
    this.isTracking = this.params.notrack ? false : true;
    this.isVanityTracking = this.params.var;
    this.fromBundle = this.params.fromBundle;

    // visitor / scan QR code => qr / var
    // OTA customer => ota / nocheckout
    // tester => tester

    if (this.fromBundle) {
      this.noCheckout = true;
    }
    if (this.params.title) {
      this.title = this.params.title;
    }

    if (this.params.lang != null) {
      try {
        this.langCode = this.params.lang;
        console.log("lang code detected: ", this.langCode);
        await this.i18nService.switchLanguageOption(this.langCode, false);
        this.applyLanguageStoryTranslation(true);
      } catch (err) {
        console.error(err);
      }
    }
  }

  applyLanguageStoryTranslation(init: boolean) {
    if (!init) {
      this.langCode = this.i18nService.langCode;
      this.langIcon = this.i18nService.langIcon;
    }
    // i18n service may expose full locale (e.g. "fr-FR"), while getLang matches short code ("fr")
    let langCode: string = this.langCode;
    if (langCode != null) {
      let iodash: number = langCode.indexOf("-");
      if (iodash !== -1) {
        langCode = langCode.slice(0, iodash);
      }
    }
    let lang: IDBModelLanguage = this.i18nService.getLang(langCode);
    console.log("lang selected: ", lang);
    if (lang != null) {
      let langId: number = lang.id;
      PromiseUtils.wrapNoAction(this.loadTranslation(langId, false), true);
    }
  }

  dispActiveCards() {
    let scenario = {
      A: this.isQRTracking || this.isVanityTracking || this.connectMode === 1, // Scan & Buy
      B: this.noCheckout || this.connectMode === 2, // Paid via OTA & Intro
      C: this.isTester || this.connectMode === 3 // Free Pass & Tester Onboarding
    };

    let isActiveScenario: boolean = false;
    for (let key in Object.keys(scenario)) {
      if (scenario[key]) {
        isActiveScenario = true;
      }
    }
    if (!isActiveScenario) {
      scenario.A = true;
    }

    this.activeCards.checkout = scenario.A;
    this.activeCards.checkoutMore = scenario.B;
    this.activeCards.registerTester = scenario.C;

    this.activeCards.checkBooking = scenario.B;

    console.log("disp active cards: ", this.activeCards);
  }

  toggleCheckout() {
    this.noCheckout = !this.noCheckout;
  }

  removeTempParams() {
    // remove temp params for next reload
    const [path, query] = this.location.path(false).split('?');
    console.log("pathname", path);
    const qparams = new HttpParams({ fromString: query });
    console.log("qparams: ", qparams);
    this.location.replaceState(path, qparams.delete('qr').toString());
    this.location.replaceState(path, qparams.delete('var').toString());
  }

  async loadUserLocation() {
    let coords: ILatLng = await this.locationManager.getCurrentLocationWrapper(true, true, true);
    console.log("story content current location: ", coords);
    this.coords = coords;
  }

  async loadAll() {
    try {
      // load story data
      await this.loadStoryWrapper(false);
      await this.loadExtData();

      if (this.isPoster) {
        if (this.story.connectMode != null) {
          this.connectMode = this.story.connectMode;
        } else {
          this.connectMode = 1;
        }
        this.dispActiveCards();
      }

      this.settings = await this.marketplaceDataService.loadSettings();
      // this.loadTutorialEmbed();
      this.loadTutorialPDF();
      this.loadTutorialVideoLink();
      if (this.isCheckout) {
        let tutorial: ITutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.checkoutNote, true);
        let params: IUnlockContentCheckoutParams = {
          title: tutorial.title,
          description: tutorial.description,
          descriptionFooter: tutorial.descriptionIos,
          iconDescription: tutorial.photoUrl,
          iconFooter: tutorial.photoUrlIos,
          unlockCodes: [this.unlockCodeGranted]
        };
        let res: number = await this.uiext.showCustomModal(null, UnlockContentCheckoutComponent, {
          view: {
            fullScreen: false,
            transparent: AppConstants.transparentMenus,
            large: true,
            addToStack: true,
            frame: false
          },
          params: params
        });
        console.log(res);
        this.checkUnlockCodes(this.story, this.unlockCodeGranted);
      }

      if (this.token != null) {
        let isTracking: boolean = this.isTracking;
        if (this.isQRTracking) {
          console.log("is QR tracking");
          isTracking = true;
          this.businessData.trackScanQR(this.storyId, this.token).then(() => {
            console.log("QR code tracked");
          }).catch((err: Error) => {
            console.error(err);
          });
        }
        if (this.isVanityTracking) {
          console.log("is vanity tracking");
          isTracking = true;
          this.businessData.trackScanVar(this.storyId, this.token).then(() => {
            console.log("vanity link tracked");
          }).catch((err: Error) => {
            console.error(err);
          });
        }
        if (isTracking) {
          console.log("is tracking");
          this.businessData.trackView(this.storyId, this.token).then(() => {
            console.log("view tracked");
          }).catch((err: Error) => {
            console.error(err);
          });
        }
      }

      console.log("preparing map");
      await this.loadContentMarkers();
      await this.loadUserLocation();
      this.createUserMarker(this.coords);
      // this.reloadMap = !this.reloadMap;
      console.log("content markers loaded");
    } catch (err) {
      console.error(err);
      this.analytics.dispatchError(err, "content");
    }
  }

  ngOnDestroy() {
    this.clearTimers();
    this.clearSub();
    this.titleService.setTitle("LP Connect");
    this.backButton.checkPop(this.vs);
  }

  swipeEvent(e) {
    this.backButton.handleSwipeEvent(e);
  }


  loadTutorialEmbed() {
    this.marketplaceDataService.requestEmbedTutorial("pages/tutorial/leplace_booktes_tutorial.html").then((resp: IGenericResponse) => {
      if (resp && resp.data) {
        this.tutorialEmbed = resp.data.html;
        console.log("tutorial embed: ", this.tutorialEmbed);
      }
    }).catch((err: Error) => {
      console.error(err);
      this.analytics.dispatchError(err, "content");
    });
  }

  loadTutorialPDF() {
    this.resourcesProvider.getInfoData(ETutorialEntries.activateStoryTutorialEn, true).then((tutorial: ITutorial) => {
      // this.tutorialEmbedPDFLink = this.domSanitizer.bypassSecurityTrustResourceUrl(tutorial.description);
      this.tutorialPreviewLink = tutorial.photoUrl;
    }).catch((err: Error) => {
      console.error(err);
      this.analytics.dispatchError(err, "content");
    });
  }

  loadTutorialVideoLink() {
    this.resourcesProvider.getInfoData(ETutorialEntries.storylineTutorialVideo, true).then((tutorial: ITutorial) => {
      // this.tutorialEmbedPDFLink = this.domSanitizer.bypassSecurityTrustResourceUrl(tutorial.description);
      this.tutorialVideoUrl = tutorial.description;
      this.tutorialVideoExtUrlMobile = tutorial.photoUrlIos;
    }).catch((err: Error) => {
      console.error(err);
      this.analytics.dispatchError(err, "content");
    });
  }

  downloadTutorial() {
    this.resourcesProvider.getInfoData(ETutorialEntries.activateStoryTutorialEn, true).then((tutorial: ITutorial) => {
      let tutorialEmbedPDFLink: string = tutorial.description;
      this.fileManager.downloadAsFileViaBrowserLocal("tutorial.pdf", tutorialEmbedPDFLink);
    }).catch((err: Error) => {
      console.error(err);
      this.analytics.dispatchError(err, "content");
    });
  }


  loadStoryWrapper(unlock: boolean) {
    console.log("load story wrapper");
    let promise = new Promise((resolve) => {
      if (unlock && this.unlockInProgress) {
        console.warn("unlock already in progress");
        resolve(null);
        return;
      }
      this.unlockInProgress = true;
      this.loadStoryFromSource(this.storyId).then(() => {
        this.unlockInProgress = false;
        if (this.animate) {
          setTimeout(() => {
            this.showState = 'active';
          }, 100);
        }
        resolve(true);
      }).catch((err: Error) => {
        this.unlockInProgress = false;
        this.analytics.dispatchError(err, "content");
        this.uiext.showAlertNoAction(Messages.msg.serverError.after.msg, ErrorMessage.parse(err, Messages.msg.serverError.after.sub));
        resolve(null);
      });
    });
    return promise;
  }

  /**
   * load story from the backend or local storage
   * @param storyId 
   */
  loadStoryFromSource(storyId: number) {
    console.log("load story: ", storyId);
    console.log("from bundle: ", this.fromBundle);
    let promise = new Promise((resolve, reject) => {
      this.loaded = false;
      if (this.token == null && !this.fromBundle) {
        this.showTokenNotFoundPopup();
        resolve(false);
        return;
      }
      this.marketplaceDataService.getStory(storyId, this.coords, this.token, this.fromBundle).then((data: IStoryResponse) => {
        this.loadStoryCore(data.story);
        this.loaded = true;
        resolve(true);
      }).catch((err: Error) => {
        console.error(err);
        this.loaded = true;
        reject(err);
      });
    });
    return promise;
  }

  showTokenNotFoundPopup() {
    let params: ICustomFiltersContainer = {
      title: "Content access error",
      filters: [
        {
          type: ESettingsType.labelOnly,
          label: "Description",
          description: "<p>Required token not found.</p><p>This might happen if you received the message through an encoded channel (such as a message from a booking platform) or because your browser or app that you used to open the page did not support it.</p><p>Please make sure to open this page in a dedicated web browser (Chrome, Safari, etc.). Copy and paste the original URL into your browser to continue. If that doesn't work, check for the original URL that might be hidden in the message that you received from the booking partner.</p>",
          enabled: true
        },
        {
          type: ESettingsType.inputText,
          label: "Original URL detected",
          value: GeneralCache.initURL,
          enabled: true
        }
      ],
      create: true
    };
    this.uiext.showCustomModal(null, CustomFormViewComponent, {
      view: {
        fullScreen: false,
        transparent: false,
        large: false,
        addToStack: false,
        frame: true
      },
      params: params
    }).then((res: ICustomFiltersContainer) => {
      if (res != null && res.create) {
        this.popupFeatures.copyToClipboard(GeneralCache.initURL);
      }
    }).catch((err: Error) => {
      console.error(err);
    });
  }

  getStandardPhoto() {
    this.resourcesProvider.getStandardPhotoByCode(EStandardCode.story + EStandardStoryCode.locked).then((photoUrl: string) => {
      this.photoUrl = photoUrl;
    }).catch((err: Error) => {
      console.error(err);
    });
  }


  loadStoryCore(story: IStory) {
    console.log("load story core: ", story);
    if (story !== null) {
      let levels: boolean[] = [];
      if (!story.islocal) {
        for (let i = 1; i <= 5; i++) {
          if (i <= story.level) {
            levels.push(true);
          } else {
            levels.push(false);
          }
        }
      }

      this.storyExt = {
        story: story,
        storyProgress: null,
        photoUrl: null,
        color: null,
        hide: false,
        show: true,
        levels: levels,
        large: false,
        modeIcon: null,
        modeText: null
      };

      this.storyExt.modeIcon = StoryUtils.getModeIcon(story);
      // this.storyExt.modeText = StoryUtils.getModeText(story);

      // show actual category (might open from global category)
      if (this.storyExt && this.storyExt.story && this.storyExt.story.categoryName) {
        this.categoryName = this.storyExt.story.categoryName.toUpperCase();
      }

      let useDefaultPhoto: boolean = SettingsManagerService.settings.app.settings.useDefaultPlacePhotos.value;

      if (this.useDefaultLocationPhotos) {
        // override settings, use only default (challenge) photos here
        useDefaultPhoto = true;
      }

      this.appLocations = this.storyExt.story.locs.map((sl: ILocationContainer) => {
        sl.merged.photoUrlSmall = LocationUtils.selectPlaceDispPhoto(sl, null, {
          hidden: useDefaultPhoto ? true : null
        });

        let appLoc: IAppLocation = {
          loc: sl,
          flag: 0,
          dispDone: false
        };
        return appLoc;
      });

      this.story = this.storyExt.story;
      this.description = (this.story.listingDescription != null && this.story.listingDescription != "") ? this.story.listingDescription : this.story.description;

      if (this.story.storyPhotos && this.story.storyPhotos.length > 0) {
        this.storyPhotos = this.story.storyPhotos;
      }

      this.potentialXp = this.gameStats.getStoryFinishedWeight(this.story);
      this.levelDisp = "Level " + this.story.level + " " + this.categoryName;

      if (this.potentialXp) {
        this.levelDisp += " (" + this.potentialXp + " XP)";
      }

      this.photoUrl = story.photoUrl;

      this.withAudioGuide = story.audioGuide != null && story.audioGuide !== 0;
      this.audioGuideAutoplay = story.audioGuide === EAudioGuide.ttsAuto;
      this.tts.setTTSVoiceOptionsContent(this.story.language, null);

      if (this.story.language != null) {
        let lang: IDBModelLanguage = this.story.language;
        if (!lang.nameLocale) {
          lang.nameLocale = lang.name;
        }
        this.languageDisp = lang;
        this.checkLanguages();
      }

      let res: ICheckStoryProviders = StoryUtils.checkLoadProvidersWizard(this.story, () => { return this.loadProviders(); });
      this.hasProviders = res.hasProviders;
      this.storyProviders = res.providers;
      this.loadBookingProviders();
      this.setupCheckout();

      this.checkUnlockCodes(story, this.unlockCodeGranted);
      this.checkDefaultAppStoreURLOverrides();
      this.checkDefaultPriceIAPOverrides();

      this.isBeta = story.devOnly === EStoryReleaseFlag.unlisted;
      this.isDev = story.devOnly === EStoryReleaseFlag.devOnly;
      this.isPremium = this.story.itemIapCode != null;

      this.resetDistFlags();

      if (this.story.city && this.story.city.country) {
        let country: IDBModelCountry = this.story.city.country;
        this.dist.android = country.enableStoreAndroid !== 0;
        this.dist.ios = country.enableStoreIos !== 0;
        if (!this.dist.android && !this.dist.ios) {
          this.dist.mobile = false;
        }
      }

      if (this.isPremium) {
        this.enableCheckout = true;
      }

      let disp = {
        isPremium: this.isPremium,
        enableCheckout: this.enableCheckout,
        releaseOnly: this.isTestFlightOnly
      };

      this.isTestFlightOnly = this.dist.mobile && !this.dist.ios;
      this.updatePageTitle(this.story.name);
      this.checkBundleContents(this.story);
      console.log("content distribution: ", disp);
      this.storyLoaded = true;
      this.storyLoadedInit = true;
    }
  }


  checkBundleContents(story: IStory) {
    this.isBundle = story.isBundle === 1;
    if (this.isBundle) {
      this.title = "Bundle";
    }
    let bundleContent: IStoryBundle[] = (story as any as IStoryBundleType).bundleContent;
    console.log("load stories from bundle: ", bundleContent);

    if (bundleContent && bundleContent.length > 0) {
      this.bundleContents = [];
      for (let bc of bundleContent) {
        let levels: boolean[] = [];
        let story: IStory = bc.story;
        if (!story.islocal) {
          for (let i = 1; i <= 5; i++) {
            if (i <= story.level) {
              levels.push(true);
            } else {
              levels.push(false);
            }
          }
        }

        story.isBundleContent = true;

        let storyWithProgress: IStoryExtended = {
          story: story,
          storyProgress: null,
          photoUrl: null,
          color: null,
          levels: levels,
          hide: false,
          show: true,
          large: false,
          modeIcon: null,
          modeText: null
        };

        if ((story.priceCoins || story.itemIapCode || story.locked) && story.regionType) {
          storyWithProgress.large = true;
        }

        storyWithProgress.modeIcon = StoryUtils.getModeIcon(story);
        // storyWithProgress.modeText = StoryUtils.getModeText(story);

        // this.canvasLoader.getCanvasURL(storyWithProgress.story.photoUrl).then((canvasUrl: string) => {
        //   storyWithProgress.canvasUrl = canvasUrl;
        //   storyWithProgress.canvasLoaded = true;
        // }).catch((err: Error) => {
        //   console.error(err);
        // });

        this.bundleContents.push(storyWithProgress);
      }

      console.log("stories with progress from bundle: ", this.bundleContents);
    } else {
      this.bundleContents = [];
    }
  }

  resetDistFlags() {
    this.dist = Object.assign({}, this.distInit);
  }

  checkDefaultPriceIAPOverrides() {
    if (!(this.story.itemIap != null && this.story.defaultPrice != null && this.story.currency != null)) {
      return;
    }
    this.alternativePrice = this.checkPriceIAPOverrides(this.story.itemIap, this.story.defaultPrice);
    if (!(this.story.itemIapPromo != null && this.story.promoPrice != null && this.story.currency != null)) {
      return;
    }
    this.alternativePricePromo = this.checkPriceIAPOverrides(this.story.itemIapPromo, this.story.promoPrice);
  }

  checkPriceIAPOverrides(itemIap: IGameItemIAP, overridePrice: string) {
    // let defaultPriceOverride: string = overridePrice + " " + this.story.currency.name;
    let priceInteger: number = Math.floor(Number.parseFloat(overridePrice) * AppConstants.gameConfig.externalPaymentDeduction * 100) / 100; // account for app store fee deduction  
    let defaultPriceStripe: string = "" + priceInteger + " " + this.story.currency.name;
    // itemIap.price = defaultPriceOverride;
    // itemIap.priceIos = defaultPriceOverride;
    return defaultPriceStripe;
  }

  checkDefaultAppStoreURLOverrides() {
    if (!(this.story.city != null && this.story.city.country != null && this.story.city.country.appStoreUrl != null)) {
      return;
    }
    this.appStoreUrl = this.story.city.country.appStoreUrl;
  }


  checkUnlockCodes(story: IStory, redeemCode: string) {
    let unlock: IStoryUnlock[] = story.storyUnlocks;
    // console.log("story unlocks: ", unlock);

    let hasActivationCodes: boolean = false;
    let hasActivationQRCodes: boolean = false;
    let hasRedeemQRCodes: boolean = false;

    let checkUnlockCode = (type: number, context: IUnlockCodeSpec, label: string, isQR: boolean) => {
      let uc: IStoryUnlock = unlock.find(u => u.enabled && u.type === type);
      if (uc != null) {
        hasActivationCodes = true;
        if (isQR) {
          hasActivationQRCodes = true;
        }
        context.name = label;
        context.length = uc.unlockCode.length;
        context.code = uc.unlockCode;
        context.show = true;
        context.isQR = isQR;
      }
    };

    let checkRedeemUnlockCode = (context: IUnlockCodeSpec, label: string, code: string, isQR: boolean) => {
      hasActivationCodes = true;
      if (isQR) {
        hasActivationQRCodes = true;
        hasRedeemQRCodes = true;
      }
      context.name = label;
      context.length = code.length;
      context.code = code;
      context.show = true;
      context.isQR = isQR;
    };

    for (let key of Object.keys(this.activationCodes)) {
      this.activationCodes[key] = {
        name: "",
        input: true,
        length: 0,
        code: null,
        show: false,
        isQR: false
      } as IUnlockCodeSpec;
    }

    checkUnlockCode(EStoryUnlockType.searchOnlyShort, this.activationCodes.searchShort, "Search Code (input)", false);
    checkUnlockCode(EStoryUnlockType.short, this.activationCodes.unlockShort, "Unlock Code (input)", false);
    checkUnlockCode(EStoryUnlockType.searchOnly, this.activationCodes.search, "Search Code (QR)", true);
    checkUnlockCode(EStoryUnlockType.branded, this.activationCodes.unlock, "Unlock Code (QR)", true);
    checkUnlockCode(EStoryUnlockType.partner, this.activationCodes.unlockPartner, "Unlock Code - Partner (QR)", true);

    if (redeemCode != null) {
      if (redeemCode.length === AppConstants.gameConfig.unlockCodeLength) {
        checkRedeemUnlockCode(this.activationCodes.redeemShort, "Unlock Code - Redeem", redeemCode, false);
      } else {
        checkRedeemUnlockCode(this.activationCodes.redeem, "Unlock Code - Redeem (QR)", redeemCode, true);
      }
    }

    if (story.partnerUnlock) {
      this.partnerUnlock = true;
      this.activationCodes.unlock.show = false;
      this.activationCodes.unlockShort.show = false;
    }

    if (hasActivationQRCodes || hasRedeemQRCodes) {
      this.activationCodes.search.show = false;
      this.activationCodes.searchShort.show = false;
    }

    this.activationCodesList = [];
    this.activationCodesQRList = [];

    hasActivationCodes = false;
    hasActivationQRCodes = false;

    for (let key of Object.keys(this.activationCodes)) {
      let ac: IUnlockCodeSpec = this.activationCodes[key];
      if (ac.show && ac.code != null) {
        hasActivationCodes = true;
        if (ac.isQR) {
          hasActivationQRCodes = true;
          this.activationCodesQRList.push(ac);
        } else {
          this.activationCodesList.push(ac);
        }
      }
    }

    this.hasActivationCodes = hasActivationCodes;
    this.hasActivationQRCodes = hasActivationQRCodes;
    this.hasRedeemQRCodes = hasRedeemQRCodes;

    console.log("list: ", this.activationCodesList)
    console.log("list - QR:", this.activationCodesQRList);
    console.log("has activation codes: ", hasActivationCodes, hasActivationQRCodes, hasRedeemQRCodes);

  }

  loadProviders() {
    this.storyProviders = [];
    this.placesData.viewStoryProviders(this.story.id).then((places: ILocationContainer[]) => {
      if (places && places.length) {
        for (let i = 0; i < places.length; i++) {
          this.storyProviders.push(places[i].db);
        }
        this.hasProviders = true;
      }
    }).catch((err) => {
      console.error(err);
    });
  }

  loadBookingProviders() {
    this.storyProducts = this.story.storyProducts;
    setTimeout(() => {
      if (this.storyProducts && this.storyProducts.length > 0) {
        this.hasStoryProducts = true;
      } else {
        this.hasStoryProducts = false;
      }
    }, 1);
  }

  setupCheckout() {
    for (let sp of this.storyProducts) {
      if (sp.providerOtaId === (EProviderPrefix.OTA + EOTA.shopify)) {
        // replace stripe checkout with shopify link
        // this.useStripe = false;
        this.shopifyLink = sp.link;
        break;
      }
    }
  }

  checkoutWithShopify() {
    if (!this.shopifyLink) {
      return;
    }
    this.openLink(this.shopifyLink);
  }

  clearTimers() {
    this.timeouts = ResourceManager.clearTimeoutObj(this.timeouts);
  }

  clearSub() {
    this.subscription.languageChanged = ResourceManager.clearSub(this.subscription.languageChanged);
  }

  /**
   * back to story list
   * @param animate 
   */
  back() {
    if (this.isModal) {
      this.dismissModal();
    } else {
      let navParams: INavParams = {
        view: null,
        params: null
      };
      if (this.fromMarket) {
        this.nps.set(ENavParamsResources.marketplaceBrowse, navParams);
        this.router.navigate([ERouteDef.marketplace], { replaceUrl: true }).then(() => {
        }).catch((err: Error) => {
          console.error(err);
        });
      } else {
        this.nps.set(ENavParamsResources.home, navParams);
        this.router.navigate([ERouteDef.home], { replaceUrl: true }).then(() => {
        }).catch((err: Error) => {
          console.error(err);
        });
      }
    }
  }

  /**
   * return from modal
   * load story flag shows if the map should load the current story
   * @param animate 
   * @param loadStory 
   */
  dismissModal() {
    let params: IMarketplaceBrowseNavParams = {
      storyId: this.storyId,
      reload: false,
      token: this.token
    };
    setTimeout(() => {
      this.modalCtrl.dismiss(params).then(() => {
      }).catch((err: Error) => {
        console.error(err);
      });
    }, 1);
  }


  presentPopover() {
    let actions: IPopoverActions = {};
    actions = {
      reload: {
        name: "Reload",
        code: 2,
        icon: EAppIconsStandard.refresh,
        enabled: true
      },
      language: {
        name: "Language",
        code: 3,
        icon: EAppIcons.translate,
        customIcon: true,
        enabled: true
      },
      return: {
        name: "Home",
        code: 1,
        icon: EAppIconsStandard.home,
        enabled: true
      }
    };

    this.uiextStandard.showStandardModal(null, EModalTypes.options, null, {
      view: {
        fullScreen: false,
        transparent: AppConstants.transparentMenus,
        large: true,
        addToStack: true,
        frame: false
      },
      params: { actions: actions }
    }).then((code: number) => {
      switch (code) {
        case 1:
          this.back();
          break;
        case 2:
          this.reload = true;
          this.loadAll();
          break;
        case 3:
          this.showLangOptions();
          break;
        default:
          break;
      }
    }).catch((err: Error) => {
      console.error(err);
    });
  }

  showPopup() {
    let description: string = "";
    if (this.storyExt) {
      description = this.storyExt.story.description;
    }
    this.uiextStandard.showStandardModal(null, EModalTypes.description, null, {
      view: {
        fullScreen: false,
        transparent: AppConstants.transparentMenus,
        large: true,
        addToStack: true,
        frame: false
      },
      params: { description: description }
    }).then(() => {

    }).catch((err: Error) => {
      console.error(err);

    });
  }

  handleQRSliderCallback(buttonCode: number, mode: number, _unlockCodeCrt: string): Promise<IQRFrameCallbackData> {
    return new Promise<IQRFrameCallbackData>((resolve) => {
      let res: IQRFrameCallbackData = {
        qrCode: null,
        dismiss: false
      };
      switch (buttonCode) {
        case 1:
          resolve(null);
          break;
        case 2:
          this.requestEmbedQR(mode);
          resolve(res);
          break;
        default:
          resolve(res);
          break;
      }
    });
  }

  hasQRCode(): boolean {
    return this.story.qrUnlock != null && this.story.qrUnlock !== EStoryUnlock.none;
  }

  showQR() {
    console.log("show qr");

    if (!this.story.qrUnlock) {
      this.uiext.showAlertNoAction(Messages.msg.qrCodeNotRegistered.after.msg, Messages.msg.qrCodeNotRegistered.after.sub);
      return;
    }

    let qrSlides: IQRCodeSlide[] = StoryQRUtils.getQRSlides(this.story, (buttonCode: number, mode: number, unlockCodeCrt: string) => this.handleQRSliderCallback(buttonCode, mode, unlockCodeCrt));

    let params: IQRFrameParams = {
      title: StringUtils.trimName(this.story.name, EMessageTrim.storyNameTitle),
      description: "Scan / paste to unlock",
      qs: qrSlides
    };

    this.uiext.showCustomModal(null, QRFrameViewComponent, {
      view: {
        fullScreen: true, // full screen only!
        transparent: AppConstants.transparentMenus,
        large: true,
        addToStack: true,
        frame: false
      },
      params: params
    }).then((res: number) => {
      console.log(res);
    }).catch((err: Error) => {
      console.error(err);
    });
  }

  requestEmbedQR(mode: number) {
    this.businessData.requestEmbedQR(this.storyId, mode).then((res: any) => {
      let embedCode: string = res.html as string;
      this.popupFeatures.copyToClipboard(embedCode);
    }).catch((err: Error) => {
      console.error(err);
      this.analytics.dispatchError(err, "content");
    });
  }

  onZoomImage(_zoom: boolean) {
    // this.zoomState = zoom;
  }

  getPlaceDetails(index) {
    console.log(index);
  }

  goToAppStore() {
    Util.openURLAdaptive(this.appStoreUrl);
  }

  goToAppleTestFlight() {
    Util.openURLAdaptive(this.testFlightUrl);
  }

  goToPlayStore() {
    Util.openURLAdaptive(this.playStoreUrl);
  }

  openWebpage() {
    Util.openURLAdaptive(this.website);
  }

  goToWeb() {
    // url += "/#/story-home?storyId=" + this.storyId;
    Util.openURLAdaptive(this.webUrl);
  }

  openLink(url: string) {
    if (!url) {
      return;
    }
    Util.openURLAdaptive(url);
  }

  goToRegisterTester() {
    Util.openURLAdaptive(this.registerTesterCalendlyUrl);
  }

  async getFreePass(event: IStoryProductBooking) {
    console.log("get free pass");
    if (event == null) {
      return;
    }
    console.log("get free pass: ", this.storyId, event.customerEmail, event.customerName, event.customerPhone, event.bookingTimestamp);
    // return;
    try {
      await this.uiext.showLoadingV2Queue("Registering..");
      let res: IBookingInterceptorResult = await this.marketplaceDataService.registerInternalBooking(this.storyId, event.customerEmail, event.customerName, event.customerPhone, event.bookingTimestamp as any, 1);
      console.log(res);
      await this.uiext.dismissLoadingV2();
      // TODO show confirmation message (render message and unlock code)
      this.dispBookingMessage(res.storyProductBooking);
    } catch (err) {
      await this.uiext.dismissLoadingV2();
      this.uiext.showAlertNoAction(Messages.msg.requestFailed.after.msg, ErrorMessage.parse(err, Messages.msg.requestFailed.after.sub), false);
    }
  }


  dispBookingMessage(spb: IStoryProductBooking) {
    this.marketplaceDataService.getBookingMessage(spb.bookingReference, spb.providerOtaId - EProviderPrefix.OTA, spb.customerName, spb.id).then((bic: IBookingInfoContent) => {
      let params: IUnlockContentCheckoutParams = {
        title: "Booking notes",
        description: bic.description,
        descriptionFooter: null,
        iconDescription: null,
        iconFooter: null,
        unlockCodes: bic.unlockCodes,
        continueBtnText: i18next.t("ui:actions.proceed") as string
      };
      this.uiext.showCustomModal(null, UnlockContentCheckoutComponent, {
        view: {
          fullScreen: false,
          transparent: AppConstants.transparentMenus,
          large: true,
          addToStack: true,
          frame: false
        },
        params: params
      }).then((res: IUnlockContentCheckoutReturnData) => {
        console.log(res);
        if (res != null) {
          if (res.actionCode === EAlertButtonCodes.ok) {

          }
        }
      }).catch((err: Error) => {
        console.error(err);
      });
    }).catch((err) => {
      console.error(err);
      this.uiext.showAlertNoAction(Messages.msg.requestFailed.after.msg, ErrorMessage.parse(err, Messages.msg.requestFailed.after.sub));
    });
  }


  /**
  * open app FB page
  */
  openFBPage() {
    // Util.openURLAdaptive(this.appDetails.fbLink);
    Util.openURLAdaptive("https://www.facebook.com/leplaceglobal/");
  }

  /**
   * write email to developers
   */
  contact() {
    // let link: string = this.appDetails.contactEmail;
    let link: string = "office@leplace.online";
    if (link) {
      link = "mailto:" + link;
      let subject = "Visitor contact from LP Connect";
      let body = "";
      let uri: string = EmailFormatUils.formatExistingContent(link, subject, body);
      // Util.openURLAdaptive(uri);
      this.fileManager.openURLAsAnchor(uri);
    }
  }

  copyToClipboard(code: string) {
    this.popupFeatures.copyToClipboard(code);
  }

  toggleActivationGuide() {
    this.showActivationGuide = !this.showActivationGuide;
  }

  async checkoutStripe() {
    try {
      if (this.isCheckout) {
        let res: number = await this.uiext.showAlert(Messages.msg.alreadyCheckedOut.before.msg, Messages.msg.alreadyCheckedOut.before.sub, 2, null, true);
        if (res === EAlertButtonCodes.cancel) {
          return;
        }
      }
      await this.uiext.showLoadingV2Queue("Redirecting to checkout..");
      let checkoutUrl: string = await this.paymentStripe.createPaymentCheckoutWizard(null, this.storyId, document.URL);
      await this.uiext.dismissLoadingV2();
      if (!this.isModal) {
        this.fileManager.openURLAsAnchor(checkoutUrl);
      } else {
        Util.openURL(checkoutUrl);
      }
      // Util.openURLAdaptive(checkoutUrl);
    } catch (err) {
      await this.uiext.dismissLoadingV2();
      this.analytics.dispatchError(err, "content");
      this.uiext.showAlertNoAction(Messages.msg.preCheckoutError.after.msg, ErrorMessage.parse(err, Messages.msg.preCheckoutError.after.sub));
    }
  }

  onProviderSlideSelected(event) {
    console.log(event);
  }

  isAppStore() {
    return this.dist.ios && !this.isTestFlightOnly;
  }

  isPlayStore() {
    return this.dist.android;
  }

  bookingCheckAction(data: IBookingCheckReturn) {
    console.log(data);
  }


  /**
   * go to story detail on story select (tapped)
   * @param story 
   */
  goToBundleStoryDetail(story: IStory, index: number): void {
    if (!story) {
      return;
    }
    console.log("view story from bundle: ", story);
    this.openStoryModal(story, index);
  }


  /**
  * open selected story as modal
  * @param story 
  */
  openStoryModal(story: IStory, index: number) {
    // get search token
    let token: string = null;
    if (story.storyUnlocks != null) {
      let su: IStoryUnlock = story.storyUnlocks.find(su => su.type === EStoryUnlockType.searchOnly);
      if (su != null) {
        token = su.unlockCode;
      } else {
        su = story.storyUnlocks.find(su => su.type === EStoryUnlockType.searchOnlyShort);
        if (su != null) {
          token = su.unlockCode;
        }
      }
    }
    let params: IMarketplaceDetailNavParams = {
      storyId: story.id,
      fromMarket: true,
      reload: true
    };

    if (token != null) {
      params.token = token;
    }

    params.fromBundle = true;
    params.title = "(" + (index + 1) + "/" + this.bundleContents.length + ") " + story.name;

    let promiseView: Promise<any>;

    promiseView = this.uiext.showCustomModal(null, MarketplaceContentPage, {
      view: {
        fullScreen: false,
        transparent: false,
        large: true,
        addToStack: true,
        frame: true
      },
      storyId: story.id,
      token: token,
      params: params
    });

    promiseView.then((res: IStoryListNavParams) => {
      if (res && res.showQR) {

      }
    }).catch((err: Error) => {
      this.uiext.showAlertNoAction(Messages.msg.storyNotAvailable.after.msg, Messages.msg.storyNotAvailable.after.sub);
      console.error(err);
    });
  }


  async loadContentMarkers() {
    try {
      this.loading = true;
      let stories: IStory[] = [];
      if (this.isBundle) {
        stories = this.bundleContents.map(sext => sext.story);
      } else {
        stories = [this.story];
      }
      this.storyMarkers = this.createMarkers(stories);

      if (this.storyMarkers && this.storyMarkers.length > 0) {
        let center = GeometryUtils.getCenterPoint(this.storyMarkers.filter(sm => sm.type !== EMarkerIconType.user));
        if (center != null) {
          this.mapCenter = [center.lat, center.lng];
        }
      }

      this.loading = false;
    } catch (err) {
      this.loading = false;
      this.uiext.showAlertNoAction(
        Messages.msg.requestFailed.after.msg,
        Messages.msg.requestFailed.after.sub
      );
      console.error(err);
    }
  }

  private createUserMarker(coords: ILatLng) {
    let marker: ILeplaceLeafletMarker = {
      lat: coords.lat,
      lng: coords.lng,
      label: "You are here",
      type: EMarkerIconType.user,
      alwaysVisible: true,
      fitBounds: false
    };
    let extMarkerIndex: number = this.storyMarkers.findIndex(mk => mk.type === EMarkerIconType.user);
    console.log("adding user marker");
    if (extMarkerIndex !== -1) {
      this.storyMarkers[extMarkerIndex] = marker;
    } else {
      this.storyMarkers.push(marker);
    }
    this.storyMarkers = [...this.storyMarkers];
  }

  private createMarkers(stories: IStory[]): ILeplaceLeafletMarker[] {
    let markers: ILeplaceLeafletMarker[] = [];
    let storyNum: string = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let bundle: boolean = this.isBundle && stories.length > 1;
    let showLocs: boolean = !this.isBundle;

    for (let i = 0; i < stories.length; i++) {
      let story: IStory = stories[i];
      let lat: number = null;
      let lng: number = null;
      if (story == null) {
        console.warn("undefined story");
        continue;
      }
      if (story.city != null) {
        lat = story.city.lat;
        lng = story.city.lng;
      }
      if (story.locs != null && story.locs.length > 0 && story.locs[0] && story.locs[0].merged) {
        lat = story.locs[0].merged.lat;
        lng = story.locs[0].merged.lng;
      }
      if (!lat || !lng) {
        continue;
      }
      let markerStory: ILeplaceLeafletMarker = {
        index: i,
        lat: lat,
        lng: lng,
        label: (this.isBundle ? (i + 1) + ". " : "") + story.name,
        data: story,
        type: EMarkerIconType.story,
        fitBounds: true,
        // scale: 1.2,
        alwaysVisible: !this.isBundle
      };
      markers.push(markerStory);

      if (showLocs) {
        for (let j = 0; j < story.locs.length; j++) {
          let loc = story.locs[j];
          if (loc != null && loc.merged != null && j > 0) {
            let markerPlace: ILeplaceLeafletMarker = {
              lat: loc.merged.lat,
              lng: loc.merged.lng,
              label: (bundle ? (i + 1) + "." : "") + (j + 1) + ". \"" + loc.merged.heading + "\"",
              data: loc.merged,
              type: EMarkerIconType.location,
              plain: true,
              fitBounds: true,
              canvasLabel: false
            };
            markers.push(markerPlace);
          }
        }
      }
    }

    return markers;
  }


  onMarkerClicked(markerData: ILeplaceLeafletMarker) {
    // this.enterStory(markerData.data);
    console.log(markerData);
    if (!markerData) {
      return;
    }
    if (this.isBundle && (markerData.type === EMarkerIconType.story)) {
      this.goToBundleStoryDetail(markerData.data, markerData.index);
    }
  }

  async showLangOptions() {
    await this.i18nService.showLangOptions();
    this.langCode = this.i18nService.langCode;
    this.langIcon = this.i18nService.langIcon;
    this.syncLangQueryParam();
  }

  private getCurrentLangQueryCode(): string {
    let langCode: string = this.i18nService.langCode || this.langCode || this.params?.lang || "en";
    let iodash: number = langCode.indexOf("-");
    if (iodash !== -1) {
      langCode = langCode.slice(0, iodash);
    }
    return langCode;
  }

  private syncLangQueryParam() {
    if (this.isModal) {
      return;
    }
    const langCode: string = this.getCurrentLangQueryCode();
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { lang: langCode },
      queryParamsHandling: 'merge',
      replaceUrl: true
    }).catch((err: Error) => {
      console.error(err);
    });
  }


  async checkLanguages() {
    try {
      this.langs = await this.marketplaceDataService.getAvailableTranslations(this.storyId);
      if (this.langs && this.langs.length > 0) {
        this.isMultiLanguage = true;
        // use default app language
        let appLang: number = GeneralCache.langId;
        if (!this.langInit) {
          this.langInit = true;
          for (let lang of this.langs) {
            if (lang.id === appLang) {
              await this.uiext.showLoadingV2Queue(Messages.toast.loadingTranslation);
              await this.loadTranslation(appLang, true);
              break;
            }
          }
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  async switchLanguage() {
    try {
      console.log("switch language");
      if (!this.langs) {
        this.langs = await this.marketplaceDataService.getAvailableTranslations(this.storyId);
      }
      let actions: IPopoverActions = {
        "1": {
          name: "English (US)",
          code: 1,
          icon: "https://leplace-storage.s3.eu-central-1.amazonaws.com/icons/flags/us.svg",
          customIcon: true,
          enabled: true
        }
      };
      for (let lang of this.langs) {
        actions["" + lang.id] = {
          name: lang.nameLocale,
          code: lang.id,
          icon: lang.icon,
          customIcon: true,
          enabled: true
        }
      }
      let result = await this.uiextStandard.showStandardModal(null, EModalTypes.options, null, {
        view: {
          fullScreen: false,
          transparent: AppConstants.transparentMenus,
          large: false,
          addToStack: true,
          frame: false
        },
        params: { actions: actions }
      });
      console.log("selected language: ", result);
      if (result != null) {
        await this.loadTranslation(result as number, false);
      }
    } catch (err) {
      console.error(err);
      this.loaded = true;
    }
  }

  async loadTranslation(id: number, withLoading: boolean) {
    try {
      this.loaded = false;
      // this.storyLoaded = false;
      this.selectedTranslationId = id;
      let translation: IStory = await this.marketplaceDataService.loadStoryTranslation(this.storyId, this.selectedTranslationId);
      StoryUtils.mergeTranslation(this.story, translation);
      this.withAudioGuide = false; // reset input
      if (withLoading) {
        await this.uiext.dismissLoadingV2();
      }
      await SleepUtils.sleep(10);
      this.loadStoryCore(this.story);
      // this.storyLoaded = true;
      this.loaded = true;
    } catch (err) {
      console.error(err);
      this.loaded = true;
    }
  }

}

